import styles from "./Section5.module.css";

export default function Section5() {
  return (
    <section className={styles.section}>
      <div className={`container ${styles.shell}`}>
        <div className={styles.contentPanel}>
          <h2>Digital Marketing and Ads Management</h2>
          <p className={styles.lead}>
            In today's digital landscape, a strong online presence is crucial
            for success. Our digital marketing and ads management services cover
            everything from search engine optimization (SEO) and pay-per-click
            (PPC) advertising to social media campaigns and content marketing.
            We use data-driven strategies to enhance your visibility, drive
            traffic to your site, and convert visitors into loyal customers. Let
            us manage your digital marketing efforts so you can focus on what
            you do best-running your business.
          </p>
        </div>

        <div className={styles.visualPanel}>
          <div className={styles.visualFrame}>
            <img
              src="/img/marketing/custom-web-developement.webp"
              alt="Website development showcase"
              className={styles.mainImage}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
